<template>
    <div>
    
        <div class="mg-y-10 tx-18" style="color: #21242e">Шинээр нэмэгдсэн сургалт</div>
        <ul v-if="$store.state.app.activeGroup.id == 9358" class="list-group list-group-flush tx-14 rounded bd">
            <router-link :to="{ name: 'lmsCourseView', 
            params: { id: c.id, bid: 0, iid: 0, bot: 0 }
            }" class="list-group-item" role="button" v-for="(c,ci) in list" :key="ci">
                <div class="d-flex align-items-center">
                    <div class="wd-20 ht-20 mg-r-10">
                        <img :src="`${c.cover}?w=20&h=20&mode=crop`" class="rounded" style="min-width: 20px" />
                    </div>
                    <span style="line-height: 1.1;">{{c.name}}</span>
                </div>
            </router-link>
        </ul>
        <ul v-else class="list-group list-group-flush tx-14 course-list-group">
            <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }" class="list-group-item d-flex pd-sm-x-20" role="button" v-for="(c,ci) in list" :key="ci">
                <div>
                    <div class="avatar wd-40 ht-40">
                        <img :src="`${c.cover}?w=40&h=40&mode=crop`" class="avatar-initial rounded-circle" />
                    </div>
                </div>
                <div class="pd-sm-l-10">
                    <p class="tx-medium mg-b-0">{{c.name}}</p>
                    <small class="tx-12 tx-color-03 mg-b-0">{{c.startDate | moment('YYYY.MM.DD')}} - {{c.endDate | moment('YYYY.MM.DD')}}</small>
                </div>
            </router-link>
        </ul>
</div>
</template>
<script>
export default {
    props:{
        list: {
        type: Array,
        default: () => []
      }
    },
}
</script>